export const KEY_MAP = {
  SKIP_TO_MAIN: { alt: true, ctrl: false, shift: false, meta: false, key: '1' },
  TOGGLE_PANEL: { alt: true, ctrl: false, shift: false, meta: false, key: 's' },
  HELP: { alt: true, ctrl: false, shift: false, meta: false, key: 'h' },
  PAUSE_ANIM: { alt: true, ctrl: false, shift: false, meta: false, key: 'p' },
  TOGGLE_FOCUS: { alt: true, ctrl: false, shift: false, meta: false, key: 'f' },
  RESET_ALL: { alt: true, ctrl: false, shift: false, meta: false, key: 'r' },
  INCREASE_TEXT: { alt: true, ctrl: false, shift: false, meta: false, key: '+' },
  DECREASE_TEXT: { alt: true, ctrl: false, shift: false, meta: false, key: '-' },
  RESET_TEXT: { alt: true, ctrl: false, shift: false, meta: false, key: '0' },
};

export function matchesKey(event, def) {
  if (!event || !def) return false;
  if (event.altKey  !== !!def.alt)  return false;
  if (event.ctrlKey !== !!def.ctrl) return false;
  if (event.shiftKey !== !!def.shift) return false;
  if (event.metaKey !== !!def.meta)  return false;
  if (!def.key) return false;
  return String(event.key).toLowerCase() === String(def.key).toLowerCase();
}
